import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-feed-help',
  templateUrl: './feed-help.component.html',
  styleUrls: ['./feed-help.component.scss']
})
export class FeedHelpComponent {
  @Input() text: string = 'Ajuda para criar Feeds?';
  @Input() videoUrl: string = '#';
  @Input() supportUrl: string = '#';

  abrirLink(url: string) {
    window.open(url, '_blank');
  }
  
}
